<template>
  <div class="circle_icon_value" :title="title">
    <div style="display: flex; flex-direction: column; align-items: center">
      <circle_icon :icon="icon" :title="title" />
      <div
        style="
          font-weight: 600;
          font-size: 16px;
          color: #0f1a3a;
          margin-top: 16px;
        "
      >
        {{ title }}
      </div>
    </div>
    <div
      style="
        font-size: 16px;
        color: #0f1a3a;
        margin-top: -20px;
        margin-left: 10px;
        display: flex;
        flex-direction: column;
      "
    >
      <div>{{ value }}</div>
      <div v-if="moreValue" style="margin-top: 20px">{{ moreValue }}</div>
    </div>
  </div>
</template>
<script>
import circle_icon from "./circle_icon.vue";
export default {
  components: { circle_icon },
  props: {
    icon: {
      type: String,
      default: "ic_zhidongqiya.png",
    },
    title: {
      type: String,
      default: "",
    },
    value: {
      type: String,
      default: "",
    },
    moreValue: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  computed: {
    src() {},
  },
  methods: {},
};
</script>
<style scoped>
.circle_icon_value {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
</style>
